"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react/jsx-runtime"),r=require("styled-components"),a=require("@vds-tokens/core"),s=require("@plans/badges"),i=require("@vds/typography"),o=require("@plans/utilities");function t(e){return e&&e.__esModule?e:{default:e}}var l=t(r);const n=l.default.li.withConfig({displayName:"Wrapper",componentId:"VDS__sc-1yb0mrl-0"})`
  align-items: center;
  background-color: ${({surface:e})=>"dark"===e?a.ColorTokens.background.secondary.dark.value:a.ColorTokens.background.primary.light.value};
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding: ${a.LayoutTokens.space["4X"].value};
  width: 100%;
`,d=l.default.div.withConfig({displayName:"TitleWrapper",componentId:"VDS__sc-1yb0mrl-1"})`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  height: ${a.LayoutTokens.space["6X"].value};
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: ${o.breakpoints.mobileLarge}) {
    height: ${a.LayoutTokens.space["5X"].value};
  }
`;exports.default=r=>{const{badge:o,title:t,surface:l="dark",className:c}=r;return e.jsxs(n,Object.assign({className:c,surface:l},{children:[e.jsx(s.Number,Object.assign({},o,{surface:l})),e.jsx(d,{children:e.jsx(i.Title,Object.assign({},t,{size:"small",color:a.ColorTokens.elements.primary[`on${l}`].value}))})]}))};
